import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import "../feature/feature.css"
import ApiRequest from "../../helper/ApiRequest";
import DataTable from '../datatable/DataTable';

const PriceEditPath = "edit-price"
const tableHeader = ["Name"];
const tbody = ["name"];

export default function AdminPrice() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", "api/plans");
      const result = response.plans;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, [useEffect]);

  return (
    <>
      <div className="header-add-category">
        <h5>Pricing</h5>
      </div>
      <div className="add-feature-section">
        {data && data.length > 0 ? "" : (
          <Link className="default-btn" to="/admin/add-price">
            Add Pricing
          </Link>
        )}
        <DataTable
          data={data && data.length > 0 ? [{ name: "Pricing Plan", _id: "pricing" },] : []}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={PriceEditPath}
        />
      </div>
    </>
  );
}
